import { createContext, useContext, useState, useCallback } from "react";
import client, { unwrap } from "@/api/client";

const AuthContext = createContext(null);

function loadUser() {
  try {
    const raw = localStorage.getItem("hi_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(loadUser);

  const persist = (data) => {
    localStorage.setItem("hi_access_token", data.accessToken);
    localStorage.setItem("hi_refresh_token", data.refreshToken);
    const userObj = { ...data.user, permissions: data.permissions, roles: data.roles };
    localStorage.setItem("hi_user", JSON.stringify(userObj));
    setUser(userObj);
    return userObj;
  };

  const login = useCallback(async (email, password) => {
    const res = await client.post("/auth/login", { email, password });
    return persist(unwrap(res));
  }, []);

  const registerShop = useCallback(async (payload) => {
    const res = await client.post("/auth/register-shop", payload);
    return unwrap(res);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("hi_access_token");
    localStorage.removeItem("hi_refresh_token");
    localStorage.removeItem("hi_user");
    setUser(null);
  }, []);

  const hasPermission = (perm) => !!user?.permissions?.includes(perm);
  const hasRole = (role) => !!user?.roles?.includes(role);
  const isPlatformAdmin = () => hasRole("PLATFORM_ADMIN");

  return (
    <AuthContext.Provider value={{ user, login, registerShop, logout, hasPermission, hasRole, isPlatformAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
